module.exports = __webpack_public_path__ + "PR5-15a904a8.webp";